/**
 * Realestate entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export enum REALESTATE_TYPE {
    LIEGENSCHAFT = 1,
    STOCKWERKS_EINHEIT = 2,
    GEWOEHNLICHES_MITEIGENTUM = 3,
    KONZESSION = 4,
    GEWOEHNLICHES_SDR = 5,
    BERGWERK = 6,
    QUELLENRECHT = 7,
    WEITERE = 8
}

export class Realestate extends BaseModel {
    public id: number | null = null;
    public dossier_id: number | null = null;
    public gid: string | null = null;
    public nbident: string | null = null;
    public nummer: string | null = null;
    public egrid: string | null = null;
    public realestate_type: REALESTATE_TYPE | null = null;
    public created: Dayjs = dayjs();
    public creator_id: number | null = null;
    public is_neighbour: boolean = false;
    public is_manually_added_neighbour: boolean = false;
    public wkb_geometry: string | null = null;
    public center_box: string | null = null;
    public center_x: number | null = null;
    public center_y: number | null = null;
    public terris_data: any | null = null;
    public av_data: any | null = null;

    mutations() {
        return {
            id: (id: number | null) => (Number(id) > 0 ? Number(id) : null),
            dossier_id: (id: number | null) => (Number(id) > 0 ? Number(id) : null),
            created: dayjs
        };
    }

    getClassName(): string {
        return 'Realestate';
    }

    public getBfsFromGid(): string {
        return this.gid?this.gid.substring(0,4):'';
    }

    get owner() {
        if (this.terris_data?.terris?.eigentuemer) {
            let res = '';
            this.terris_data?.terris?.eigentuemer.forEach((e: any) => {
                if (res !== '') {
                    res += '\n';
                }
                if (e.typ === 'J') {
                    res += e.name + ', ' + e.plz + ' ' + e.ort;
                } else {
                    res += e.vorname + ' ' + e.name + ', ' + e.plz + ' ' + e.ort;
                }
            });
            return res;
        }
        return '';

    }
}

export class RealestateCollection extends BaseCollection<Realestate> {
    protected modelCls = Realestate;

    public getModelClassName(): string {
        return 'Realestate';
    }
}
